import React from 'react'
import {Lang} from 'yougile-lang'
import {ItemContainer} from './item-container'
import {TwItemTitleSupport, TwTitle, TwTitle2} from './tw'

export const WaitingLicense = ({waiting}: {waiting: boolean}) => {
  if (!waiting) {
    return null
  }

  return (
    <>
      <div className="flex gap-8 flex-col">
        <TwTitle>{Lang.msg.noLicense.welcomeToYouGile}</TwTitle>
        <TwTitle2>{Lang.msg.noLicense.welcomeToYouGile2}</TwTitle2>
      </div>

      <div className="flex flex-row gap-24 mt-24 mx-auto w-fit">
        <ItemContainer size="big">
          {false && (
            <TwTitle2 className="text-primary mx-auto">
              {Lang.msg.noLicense.licenseNotActivated}
            </TwTitle2>
          )}
          <TwItemTitleSupport className="mt-8 !leading-[20px]">
            {Lang.msg.noLicense.activateInProgress}
          </TwItemTitleSupport>
        </ItemContainer>
      </div>
    </>
  )
}
